import { LayoutTemplate, Palette, Gauge, Wrench } from "lucide-react";
import Reveal from "@/components/site/Reveal";

const services = [
  {
    icon: LayoutTemplate,
    title: "Custom Marketing Sites",
    body: "Landing pages, full company sites, and product launches — designed to convert and engineered to last.",
    accent: "from-violet-500/20 to-transparent",
  },
  {
    icon: Palette,
    title: "Brand-First Design",
    body: "Layouts, typography, and motion crafted around your voice. Nothing generic, nothing borrowed.",
    accent: "from-fuchsia-500/15 to-transparent",
  },
  {
    icon: Gauge,
    title: "Performance & SEO",
    body: "Sub-second loads, clean semantic markup, and on-page SEO baked in from day one.",
    accent: "from-indigo-500/15 to-transparent",
  },
  {
    icon: Wrench,
    title: "Care & Iteration",
    body: "Post-launch updates, copy tweaks, new sections — a single point of contact, always.",
    accent: "from-purple-500/15 to-transparent",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <Reveal className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14">
          <div className="max-w-2xl">
            <div className="font-mono-label text-[11px] text-violet-400 mb-6">
              02 / What I build
            </div>
            <h2
              data-testid="services-heading"
              className="font-display text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05] text-white"
            >
              Websites, end to end.
              <br />
              <span className="text-white/60">Designed and built by hand.</span>
            </h2>
          </div>
          <p className="text-white/55 text-sm md:text-base max-w-md leading-relaxed">
            Every project is scoped to your brand and goals. Below is what most engagements look
            like — combined or à la carte, you decide.
          </p>
        </Reveal>

        <div
          data-testid="services-cards"
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5"
        >
          {services.map((s, i) => (
            <Reveal key={i} delay={i * 110} y={32}>
              <ServiceCard index={i} {...s} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

function ServiceCard({ icon: Icon, title, body, accent, index }) {
  return (
    <div
      data-testid={`service-card-${index}`}
      className="card-glass relative overflow-hidden rounded-2xl p-7 group"
    >
      <div
        aria-hidden
        className={`absolute -top-20 -right-20 h-56 w-56 rounded-full bg-gradient-to-br ${accent} blur-3xl opacity-80 group-hover:opacity-100 transition-opacity`}
      />
      <div className="relative">
        <div className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-white/5 border border-white/10 mb-6">
          <Icon size={18} className="text-violet-300" />
        </div>
        <div className="font-mono-label text-[10px] text-white/30 mb-2">
          {String(index + 1).padStart(2, "0")}
        </div>
        <h3 className="font-display text-xl font-bold text-white mb-3 leading-tight">
          {title}
        </h3>
        <p className="text-sm text-white/60 leading-relaxed">{body}</p>
      </div>
    </div>
  );
}
